// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"435d41fd","399":"9d85dfa6","509":"645d2afc","694":"91a800b4","914":"107720fa","931":"f49d0818"}[chunkId] + ".chunk.js";
};